import { render } from "./Folders.vue?vue&type=template&id=20edcce1"
import script from "./Folders.vue?vue&type=script&lang=js"
export * from "./Folders.vue?vue&type=script&lang=js"

import "../styles/folders.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__